import linkData from '@/base/linkData'
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {},
  mb_widgets_infor: {
    set_style: {
      background:{
        radio_val: 'default',
        default:{
          type:'color', // 背景设置-类型
          img:'', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'auto',
          background_repeat: 'repeat',
          background_position: 'center center' //图片位置
        },
        custom:{
          type:'color', // 背景设置-类型
          img:'', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
          img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'auto',
          background_repeat: 'repeat',
          background_position: 'center center' //图片位置
        }
      },
      border: { // 边框
        radio_val: 'default',
        default: {
          borderColor: 'rgba(0, 0, 0,1)',
          borderWidth: 0,
          borderStyle: 'solid'
        },
        custom: {
          borderColor: 'rgba(0, 0, 0,1)',
          borderWidth: 0,
          borderStyle: 'solid'
        }
      },
      splitLine: { // 分割线
        radio_val: 'default',
        default: {
          borderColor: 'rgba(0, 0, 0,1)',
          borderWidth: 0,
          borderStyle: 'solid'
        },
        custom: {
          borderColor: 'rgba(0, 0, 0,1)',
          borderWidth: 0,
          borderStyle: 'solid'
        }
      },
      content_style: '1' // '1' 图+文字 '2' 纯文字 '3' 纯图标
    },
    default_item: {
      icon: { // 图标默认项
        radio_val: 'default',
        default: {
          color: 'rgba(255, 255, 255, 1)'
        },
        custom: {
          color: 'rgba(255, 255, 255, 1)'
        }
      },
      font: {
        radio_val: 'default',
        default: {
          fontFamily: 'Arial',
          fontSize: 12,
          color: 'rgba(33, 33, 33, 1)',
          fontWeight: 'normal',
          fontStyle: 'normal',
          textDecoration: 'none'
        },
        custom: {
          fontFamily: 'Arial',
          fontSize: 12,
          color: 'rgba(33, 33, 33, 1)',
          fontWeight: 'normal',
          fontStyle: 'normal',
          textDecoration: 'none'
        }
      }
    },
    select_item: {
      icon: { // 图标选中项
        radio_val: 'default',
        default: {
          color: 'rgba(255, 255, 255, 1)'
        },
        custom: {
          color: 'rgba(255, 255, 255, 1)'
        }
      },
      font: {
        radio_val: 'default',
        default: {
          fontFamily: 'Arial',
          fontSize: 12,
          color: 'rgba(33, 33, 33, 1)',
          fontWeight: 'normal',
          fontStyle: 'normal',
          textDecoration: 'none'
        },
        custom: {
          fontFamily: 'Arial',
          fontSize: 12,
          color: 'rgba(33, 33, 33, 1)',
          fontWeight: 'normal',
          fontStyle: 'normal',
          textDecoration: 'none'
        }
      }
    }
  },
  listArr: {
    nav_list: [{
      name: 'Home', //导航名称
      intro: linkData, // 导航预览跳转链接
      router_name: 'Home', //导航链接名称
      img_type: 'icon', // icon 图标 img 图片
      img: 'home',// 导航图标
      isHide: 'false',//是否隐藏
      children: [],
      childIsShow: 'true'
    },
    {
      name: 'About us',
      intro: linkData,
      router_name: 'About us',
      img_type: 'icon',
      img: 'user',
      isHide: 'false',
      children: [],
      childIsShow: 'true'
    },
    {
      name: 'Service cases',
      intro: linkData,
      router_name: 'Service cases',
      img_type: 'icon',
      img: 'th-large',
      isHide: 'false',
      children: [],
      childIsShow: 'true'
    },
    {
      name: 'News center',
      intro: linkData,
      router_name: 'News center',
      img_type: 'icon',
      img: 'file',
      isHide: 'false',
      children: [],
      childIsShow: 'true'
    },
    {
      name: 'Contact us',
      intro: linkData,
      router_name: 'Contact us',
      img_type: 'icon',
      img: 'phone',
      isHide: 'false',
      children: [],
      childIsShow: 'true'
    }],// 导航列表
    module_style: 0, // 样式选择
    style_color: '', // 选择的颜色
    style_color_type: 'default' //选择颜色的key值
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_footnav/style.js